import { render, staticRenderFns } from "./VehicleExtras.vue?vue&type=template&id=6ce9fbce&scoped=true"
import script from "./VehicleExtras.vue?vue&type=script&lang=js"
export * from "./VehicleExtras.vue?vue&type=script&lang=js"
import style0 from "./VehicleExtras.vue?vue&type=style&index=0&id=6ce9fbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce9fbce",
  null
  
)

export default component.exports